import axios from 'axios';

const BASE_URL = process.env.NODE_ENV === "development" ? 'http://localhost:54680/api/' : "/api/";
axios.defaults.headers.common["Content-Type"] = 'application/json';

export function login(model) {
    delete axios.defaults.headers.common["Authorization"];        
    return axios({
        url: `${BASE_URL}token`,
        method: "POST",
        data: `grant_type=password&username=${model.username}&password=${model.password}`,
        headers:{
            "Content-Type":"application/x-www-form-urlencoded"
        }
    });
}

export function changePassword(model){
    return axios.post(`${BASE_URL}account/changePassword`, model)
        .then(res => res.data);
}

export function checkUsername(username){
    if(!username) return Promise.resolve({});   
    return axios.get(`${BASE_URL}account/checkUsername?username=${username}`)
        .then(res => res.data);
}

export function getStates(){
    return axios.get(`${BASE_URL}states`)
        .then(res => res.data);
}

export function uploadFile(file){
    return axios.post(`${BASE_URL}upload/upload`, file, {
        headers:{
            'Content-Type':'multipart/form-data'
        }
    })
}

export function getAdminInformation(){
    return axios.get(`${BASE_URL}ev_client`)
        .then(res => res.data);
}

export function updateAdminInformation(model){
    return axios.put(`${BASE_URL}ev_client/${model.id}`, model)
        .then(res => res.data);
}


export function getVotingCentersInformation(){
    return axios.get(`${BASE_URL}ev_center`)
        .then(res => res.data);
}

export function createVotingCenter(model){
    return axios.post(`${BASE_URL}ev_center`, model)
        .then(res => res.data);
}

export function getHistoryId(id){
    return axios.get(`${BASE_URL}getCenter/GetHistoryId?centerId=${id}`)
        .then(res => res.data);
}

export function getVotingCenterDetails(id){
    return axios.get(`${BASE_URL}ev_center/${id}`)
        .then(res => res.data);
}

export function updateVotingCenter(model){
    return axios.put(`${BASE_URL}ev_center/${model.id}`, model)
        .then(res => res.data);
}

export function deleteVotingCenter(id){
    return axios.delete(`${BASE_URL}ev_center/${id}`)
        .then(res => res.data);
}

export function getCaptionInfo(){
    return axios.get(`${BASE_URL}centerLogin`)
        .then(res => res.data)
}

export function updateCenterTime(model){
    return axios.put(`${BASE_URL}centerLogin/${model.id}`, model)
        .then(res => res.data);
}

export function getPublicClientInformation(url){
    return axios.get(`${BASE_URL}getClient/${url}`)
        .then(res => res.data);
}

export function getPublicVotingCenters(url){
    return axios.get(`${BASE_URL}getCenter/${url}`)
        .then(res => res.data);
}


// WEBPACK FOOTER //
// ./src/utils/api.js